<template>
    <div class="app-inner" id="indexConfig"
    v-loading="Htmlloading"
     element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    element-loading-text="先喝杯茶～～"
    >
        <div class="public-btn-small flex align-cen posta">
           <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="onSubmit"
            >
            提交
           </el-button>
            </div>
     <el-tabs  type="border-card" v-model="activeIndex">
    <el-tab-pane name="1">
        <span slot="label"><i class="icon-al-home"></i> 首页</span>
        <div class="indexHome">
                 <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="el-icon-picture-outline"></i>  企业LOGO
            </div>
        </div>
             <div class="businessList-filter" style="margin:10px 0">
                    <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
                    <div class="el-select1">
                     <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :before-upload="$util.beforeUpload"
                     :on-success="(res)=>{handlePictureCardSuccess(res,1)}"
                    :disabled="uploadBoolean1"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">120*40</span></div>
                         <img :src="params.index.logo" class="avatar" v-if="params.index.logo">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="params.index.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(1)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(1)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                 <el-dialog :visible.sync="picDialog0" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="params.index.logo" alt="">
                    </el-dialog>
                    </el-upload>
                    </div>
                    </div>
                </div>
              <div class="public-tit flex align-cen" style="margin-top:20px">
                <div class="public-tit-list">
                    <i class="icon-al-edit"></i> 文字标题
                </div>
            </div>
                <div class="businessList-filter-list flex align-cen">
                       <div class="fl-le flex align-cen">
                        <div class="label">文字标题1：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入文字标题1" v-model="params.index.title1" clearable maxlength="20"> </el-input>
                    </div>
                     </div>
                    <div class="fl-rt flex align-cen">
                        <div class="label">文字标题2：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入文字标题2" v-model="params.index.title2" clearable maxlength="20"> </el-input>
                    </div>
                     </div>
                </div>
                 <div class="businessList-filter-list flex align-cen">
                         <div class="fl-le flex align-cen">
                        <div class="label">文字标题3：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入文字标题3" v-model="params.index.title3" clearable maxlength="20"> </el-input>
                    </div>
                     </div>
                        <div class="fl-rt flex align-cen">
                        <div class="label">文字标题4：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入文字标题4" v-model="params.index.title4" clearable maxlength="20"> </el-input>
                    </div>
                     </div>
                 </div>
                 <div class="el-price-table flex align-cen"  style="width: 1440px;">
                    <div class="table-label" style="max-width: 200px;">合作伙伴LOGO：</div>
                    <div class="moreImg"  style="max-width: 1200px;">
                            <el-upload
                    class="avatar-uploaderlogo"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    list-type="picture-card"
                     :file-list="params.index.moreImg"
                    :on-change="(file,fileList)=>{handleChange(file,fileList,1)}"
                    :before-upload="$util.beforeUpload"
                    :on-preview="(file)=>{handlePictureCardPreview(file,1)}"
                    :on-remove="(file,fileList)=>{handleRemove(file,fileList,1)}"
                    >
                     <i class="el-icon-plus"></i>
                     <div class="el-upload__tip" slot="tip">上传合作伙伴logo，建议尺寸 <span style="color:red">240*80,白底背景</span> </div>
                      </el-upload>
                    </div>
                       <el-dialog :visible.sync="dialogVisible1" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                 </div>
                    <div class="public-tit flex align-cen" style="margin-top:20px">
                <div class="public-tit-list">
                    <i class="el-icon-picture"></i> 公司资质证件
                </div>
            </div>
                  <div class="el-price-table flex align-cen" style="max-width: 840px;">
                    <div class="moreImg">
                            <el-upload
                    class="avatar-uploaderlogo1"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    list-type="picture-card"
                     :file-list="params.index.moreTimg"
                    :on-change="(res,file)=>{handleChange(res,file,2)}"
                    :before-upload="$util.beforeUpload"
                    :on-preview="(file)=>{handlePictureCardPreview(file,2)}"
                    :on-remove="(res,file)=>{handleRemove(res,file,2)}"
                    >
                     <i class="el-icon-plus"></i>
                     <div class="el-upload__tip" slot="tip">上传公司资质证件，建议尺寸 <span style="color:red">373*252</span> </div>
                      </el-upload>
                    </div>
                       <el-dialog :visible.sync="dialogVisible2" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="dialogImageUrl1" alt="">
                    </el-dialog>
                 </div>
                    <div class="public-tit flex align-cen" style="margin-top:20px">
                <div class="public-tit-list">
                    <i class="el-icon-picture"></i> 服务宗旨
                </div>
            </div>
            <div slot="tip" class="el-upload__tip"  style="margin-top:20px">建议尺寸：<span style="color:#f56c6c">40*40</span></div>
                     <div class="el-price-serve flex align-cen">
                  <div class="serve-upload-list">
                          <div class="el-select1">
                     <el-upload
                    class="pic-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :before-upload="$util.beforeUpload"
                    :on-success="(res)=>{handlePictureCardSuccess(res,2)}"
                    :disabled="uploadBoolean2"
                    >
                    
                    <div slot="tip" class="el-upload__tip" ><el-input placeholder="服务宗旨1上" v-model="params.index.serveText1" clearable maxlength="20"> </el-input></div>
                    <div slot="tip" class="el-upload__tip" ><el-input placeholder="服务宗旨1下" v-model="params.index.serveBotText1" clearable maxlength="20"> </el-input></div>
                         <img :src="params.index.pic1" class="avatar" v-if="params.index.pic1">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="params.index.pic1" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(2)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(2)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                 <el-dialog :visible.sync="picDialog1" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="params.index.pic1" alt="">
                    </el-dialog>
                    </el-upload>
                    </div>
                  </div>
                    <div class="serve-upload-list">
                          <div class="el-select1">
                     <el-upload
                    class="pic-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :before-upload="$util.beforeUpload"
                    :on-success="(res)=>{handlePictureCardSuccess(res,3)}"
                    :disabled="uploadBoolean3"
                    >
                    
                    <div slot="tip" class="el-upload__tip" ><el-input placeholder="服务宗旨2上" v-model="params.index.serveText2" clearable maxlength="20"> </el-input></div>
                     <div slot="tip" class="el-upload__tip" ><el-input placeholder="服务宗旨2下" v-model="params.index.serveBotText2" clearable maxlength="20"> </el-input></div>
                         <img :src="params.index.pic2" class="avatar" v-if="params.index.pic2">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="params.index.pic2" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(3)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(3)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                 <el-dialog :visible.sync="picDialog2" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="params.index.pic2" alt="">
                    </el-dialog>
                    </el-upload>
                    </div>
                  </div>
                        <div class="serve-upload-list">
                          <div class="el-select1">
                     <el-upload
                    class="pic-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :before-upload="$util.beforeUpload"
                    :on-success="(res)=>{handlePictureCardSuccess(res,4)}"
                    :disabled="uploadBoolean4"
                    >
                    
                    <div slot="tip" class="el-upload__tip" ><el-input placeholder="服务宗旨3上" v-model="params.index.serveText3" clearable maxlength="20"> </el-input></div>
                     <div slot="tip" class="el-upload__tip" ><el-input placeholder="服务宗旨3下" v-model="params.index.serveBotText3" clearable maxlength="20"> </el-input></div>
                         <img :src="params.index.pic3" class="avatar" v-if="params.index.pic3">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="params.index.pic3" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(4)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(4)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                 <el-dialog :visible.sync="picDialog3" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="params.index.pic3" alt="">
                    </el-dialog>
                    </el-upload>
                    </div>
                  </div>
                           <div class="serve-upload-list">
                          <div class="el-select1">
                     <el-upload
                    class="pic-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :before-upload="$util.beforeUpload"
                    :on-success="(res)=>{handlePictureCardSuccess(res,5)}"
                    :disabled="uploadBoolean5"
                    >
                    
                    <div slot="tip" class="el-upload__tip" ><el-input placeholder="服务宗旨4上" v-model="params.index.serveText4" clearable maxlength="20"> </el-input></div>
                     <div slot="tip" class="el-upload__tip" ><el-input placeholder="服务宗旨4下" v-model="params.index.serveBotText4" clearable maxlength="20"> </el-input></div>
                         <img :src="params.index.pic4" class="avatar" v-if="params.index.pic4">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="params.index.pic4" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(5)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(5)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                 <el-dialog :visible.sync="picDialog4" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="params.index.pic4" alt="">
                    </el-dialog>
                    </el-upload>
                    </div>
                  </div>
                 </div>
             </div>
        </div>
    </el-tab-pane>
    <el-tab-pane name="2">
       <span slot="label"><i class="icon-al-user-group-fill"></i> 合作客户</span>
       <div class="partner">
               <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-edit"></i>  文字标题
            </div>
        </div>
            <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
                       <div class="fl-le flex align-cen">
                        <div class="label">文字标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入文字标题" v-model="params.partner.title1" clearable maxlength="20"> </el-input>
                    </div>
                     </div>
                    <div class="fl-rt flex align-cen">
                        <div class="label">副文案：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副文案" v-model="params.partner.title1s" clearable maxlength="20"> </el-input>
                    </div>
                     </div>
                </div>
                     <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
                     <div class="fl-le flex align-cen">
                       <div class="label">合作顶图：</div>
                    <div class="el-select1">
                     <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :before-upload="$util.beforeUpload"
                     :on-success="(res)=>{handlePictureCardSuccess(res,13)}"
                    :disabled="uploadBoolean13"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">1920*396</span></div>
                         <img :src="params.partner.logo" class="avatar" v-if="params.partner.logo">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="params.partner.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(13)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(13)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                 <el-dialog :visible.sync="picDialog12" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="params.partner.logo" alt="">
                    </el-dialog>
                    </el-upload>
                    </div>
                    </div>
                </div>
                 <!-- <div class="public-tit flex align-cen" style="margin-top:20px" id="addCanvas" v-if="platformAppContentList.length == 0">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  分类
            </div>
               <div class="mft public-btn-small">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(-1,0)"
                     >
                          添加分类  
                    </div>
                </div>
        </div> -->
                <!-- <div class="AppContent">
                    <div class="moreCanvas"
                     v-for="(item,index) in platformAppContentList"
                    :key="index"
                    :id="'addCanvas'+index"
                    >
                            <div class="public-tit flex align-cen" style="margin-bottom:20px">
                        <div class="public-tit-list">
                            <i class="icon-al-database-fill"></i> 分类{{index+1}}
                        </div>
                    </div>
                             <div class="businessList-filter-list flex align-cen">
                        <div class="fl-le flex align-cen">
                    <div class="label">分类标题：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入分类标题【1-5】" v-model="item.title" clearable
                        maxlength="5"
                        > </el-input>
                    </div>
                    </div>
                        <div class="fl-rt flex align-cen">
                    <div class="label">副标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副标题【1-50】" v-model="item.subhead" clearable maxlength="50"> </el-input>
                    </div>
                    </div>
                    <div class="mft deletBtn"
                    @click="deletCanvas(item,index,0)"
                    >
                    删除分类
                    </div>
                    <div class="mft public-btn-small" style="padding-left:0" v-if="index == platformAppContentList.length-1">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(index+1,0)"
                     >
                          添加分类  
                    </div>
                </div>
                </div>
                  <quillsTemplate  @sendStatus="emitFun" 
                     :propData="item.content"
                     :currindex="index"
                     :tempname="0"
                     :activeIndex="activeIndex"
                    :ref="'quillTemplate' + index"
                    ></quillsTemplate>
        </div>
                  
              </div> -->
       </div>
    </el-tab-pane>
    <el-tab-pane  name="3">
       <span slot="label"><i class="icon-al-news"></i> 新闻动态</span>
       <div class="news">
             <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-edit"></i>  标题及顶图
            </div>
        </div>
         <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
            <div class="fl-le flex align-cen">
                        <div class="label">文字标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入文字标题" v-model="params.news.title1" clearable maxlength="20"> </el-input>
                    </div>
                  </div>
                <div class="fl-rt flex align-cen">
                        <div class="label">副文案：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副文案" v-model="params.news.title1s" clearable maxlength="20"> </el-input>
                    </div>
                 </div>
         </div>
              <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
                     <div class="fl-le flex align-cen">
                       <div class="label">新闻顶图：</div>
                    <div class="el-select1">
                     <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :before-upload="$util.beforeUpload"
                     :on-success="(res)=>{handlePictureCardSuccess(res,6)}"
                    :disabled="uploadBoolean6"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">1920*396</span></div>
                         <img :src="params.news.logo" class="avatar" v-if="params.news.logo">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="params.news.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(6)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(6)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                 <el-dialog :visible.sync="picDialog5" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="params.news.logo" alt="">
                    </el-dialog>
                    </el-upload>
                    </div>
                    </div>
                </div>
       </div>
    </el-tab-pane>
    <el-tab-pane label="帮助中心" name="4">
        <span slot="label"><i class="icon-al-question-circle"></i> 帮助中心</span>
        <div class="help">
             <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-edit"></i>  标题及顶图
            </div>
        </div>
         <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
            <div class="fl-le flex align-cen">
                        <div class="label">文字标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入文字标题" v-model="params.help.title1" clearable maxlength="20"> </el-input>
                    </div>
               </div>
                 <div class="fl-rt flex align-cen">
                        <div class="label">副文案：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副文案" v-model="params.help.title1s" clearable maxlength="20"> </el-input>
                    </div>
                 </div>
         </div>
           <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
             <div class="fl-le flex align-cen">
                       <div class="label">帮助中心顶图：</div>
                    <div class="el-select1">
                     <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :before-upload="$util.beforeUpload"
                     :on-success="(res)=>{handlePictureCardSuccess(res,7)}"
                    :disabled="uploadBoolean7"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">1920*396</span></div>
                         <img :src="params.help.logo" class="avatar" v-if="params.help.logo">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="params.help.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(7)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(7)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                 <el-dialog :visible.sync="picDialog6" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="params.help.logo" alt="">
                    </el-dialog>
                    </el-upload>
                    </div>
                    </div>
           </div>
        </div>
    </el-tab-pane>
    <el-tab-pane label="董事长致词" name="5" :disabled="chdis" >
        <span slot="label" ><i class="icon-al-file-fill"></i> 董事长致辞</span>
        <div class="chairman">
            <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-edit"></i>  标题及顶图
            </div>
        </div>
          <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
            <div class="fl-le flex align-cen">
                        <div class="label">文字标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入文字标题" v-model="params.chairman.title1" clearable maxlength="20"> </el-input>
                    </div>
               </div>
                 <div class="fl-rt flex align-cen">
                        <div class="label">副文案：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副文案" v-model="params.chairman.title1s" clearable maxlength="20"> </el-input>
                    </div>
                 </div>
         </div>
          <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
              <div class="fl-le flex align-cen">
                       <div class="label">董事长致辞顶图：</div>
                    <div class="el-select1">
                     <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :before-upload="$util.beforeUpload"
                     :on-success="(res)=>{handlePictureCardSuccess(res,8)}"
                    :disabled="uploadBoolean8"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">1920*396</span></div>
                         <img :src="params.chairman.logo" class="avatar" v-if="params.chairman.logo">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="params.chairman.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(8)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(8)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                 <el-dialog :visible.sync="picDialog7" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="params.chairman.logo" alt="">
                    </el-dialog>
                    </el-upload>
                    </div>
                    </div>
          </div>
         <div class="public-tit flex align-cen" style="margin-top:20px" id="addCanvas" v-if="chairmanList.length == 0">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  分类
            </div>
               <div class="mft public-btn-small">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(-1,1)"
                     >
                          添加分类  
                    </div>
                </div>
        </div>
                      <div class="AppContent">
                    <div class="moreCanvas"
                     v-for="(item,index) in chairmanList"
                    :key="index"
                    :id="'addCanvas'+index"
                    >
                            <div class="public-tit flex align-cen" style="margin-bottom:20px">
                        <div class="public-tit-list">
                            <i class="icon-al-database-fill"></i> 分类{{index+1}}
                        </div>
                    </div>
                             <div class="businessList-filter-list flex align-cen">
                        <div class="fl-le flex align-cen">
                    <div class="label">分类标题：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入分类标题【1-5】" v-model="item.title" clearable
                        maxlength="5"
                        > </el-input>
                    </div>
                    </div>
                        <div class="fl-rt flex align-cen">
                    <div class="label">副标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副标题【1-50】" v-model="item.subhead" clearable maxlength="50"> </el-input>
                    </div>
                    </div>
                    <div class="mft deletBtn"
                    @click="deletCanvas(item,index,1)"
                    >
                    删除分类
                    </div>
                    <div class="mft public-btn-small" style="padding-left:0" v-if="index == chairmanList.length-1">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(index+1,1)"
                     >
                          添加分类  
                    </div>
                </div>
                </div>
                  <quillsTemplate  @sendStatus="emitFun" 
                     :propData="item.content"
                     :currindex="index"
                     :tempname="1"
                     :activeIndex="activeIndex"
                    :ref="'quillTemplate' + index"
                    ></quillsTemplate>
        </div>
          </div>
        </div>
    </el-tab-pane>
    <el-tab-pane label="人才招聘" name="6">
       <span slot="label"><i class="icon-al-userplus-fill"></i>人才招聘</span>
        <div class="recruit">
            <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-edit"></i>  标题及顶图
            </div>
        </div>
           <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
            <div class="fl-le flex align-cen">
                        <div class="label">文字标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入文字标题" v-model="params.recruit.title1" clearable maxlength="20"> </el-input>
                    </div>
               </div>
                 <div class="fl-rt flex align-cen">
                        <div class="label">副文案：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副文案" v-model="params.recruit.title1s" clearable maxlength="20"> </el-input>
                    </div>
                 </div>
         </div>
          <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
             <div class="fl-le flex align-cen">
                       <div class="label">人才招聘顶图：</div>
                    <div class="el-select1">
                     <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :before-upload="$util.beforeUpload"
                     :on-success="(res)=>{handlePictureCardSuccess(res,9)}"
                    :disabled="uploadBoolean9"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">1920*396</span></div>
                         <img :src="params.recruit.logo" class="avatar" v-if="params.recruit.logo">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="params.recruit.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(9)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(9)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                 <el-dialog :visible.sync="picDialog8" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="params.recruit.logo" alt="">
                    </el-dialog>
                    </el-upload>
                    </div>
                    </div>
           </div>
        </div>
    </el-tab-pane>
    <el-tab-pane label="了解和隆优化" name="7">
      <span slot="label"><i class="icon-al-search"></i>了解和隆优化</span>
      <div class="hlyh">
           <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-edit"></i>  标题及顶图
            </div>
        </div>
             <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
            <div class="fl-le flex align-cen">
                        <div class="label">文字标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入文字标题" v-model="params.hlyh.title1" clearable maxlength="20"> </el-input>
                    </div>
               </div>
                 <div class="fl-rt flex align-cen">
                        <div class="label" style="width:120px">副文案：</div>
                    <div class="el-select1">
                    <el-input placeholder="副文案" v-model="params.hlyh.title1s" clearable maxlength="20"> </el-input>
                    </div>
                 </div>
         </div>
         <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
             <div class="fl-le flex align-cen">
                       <div class="label">了解顶图：</div>
                    <div class="el-select1">
                     <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :before-upload="$util.beforeUpload"
                     :on-success="(res)=>{handlePictureCardSuccess(res,10)}"
                    :disabled="uploadBoolean10"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">1920*396</span></div>
                         <img :src="params.hlyh.logo" class="avatar" v-if="params.hlyh.logo">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="params.hlyh.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(10)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(10)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                 <el-dialog :visible.sync="picDialog9" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="params.hlyh.logo" alt="">
                    </el-dialog>
                    </el-upload>
                    </div>
                    </div>
           </div>
           <!-- 富文本 -->
            <div class="public-tit flex align-cen" style="margin-top:20px" id="addCanvas" v-if="hlyhList.length == 0">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  分类
            </div>
               <div class="mft public-btn-small">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(-1,2)"
                     >
                          添加分类  
                    </div>
                </div>
        </div>
                  <div class="AppContent">
                    <div class="moreCanvas"
                     v-for="(item,index) in hlyhList"
                    :key="index"
                    :id="'addCanvas'+index"
                    >
                            <div class="public-tit flex align-cen" style="margin-bottom:20px">
                        <div class="public-tit-list">
                            <i class="icon-al-database-fill"></i> 分类{{index+1}}
                        </div>
                    </div>
                             <div class="businessList-filter-list flex align-cen">
                        <div class="fl-le flex align-cen">
                    <div class="label">分类标题：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入分类标题【1-5】" v-model="item.title" clearable
                        maxlength="5"
                        > </el-input>
                    </div>
                    </div>
                        <div class="fl-rt flex align-cen">
                    <div class="label">副标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副标题【1-50】" v-model="item.subhead" clearable maxlength="50"> </el-input>
                    </div>
                    </div>
                    <div class="mft deletBtn"
                    @click="deletCanvas(item,index,2)"
                    >
                    删除分类
                    </div>
                    <div class="mft public-btn-small" style="padding-left:0" v-if="index == hlyhList.length-1">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(index+1,2)"
                     >
                          添加分类  
                    </div>
                </div>
                </div>
                  <quillsTemplate  @sendStatus="emitFun" 
                     :propData="item.content"
                     :currindex="index"
                     :tempname="2"
                     :activeIndex="activeIndex"
                    :ref="'quillTemplate' + index"
                    ></quillsTemplate>
        </div>
          </div>
      </div>
    </el-tab-pane>
     <el-tab-pane label="联系我们" name="8">
       <span slot="label"><i class="icon-al-mobile-check"></i>联系我们</span>
       <div class="contact">
             <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-edit"></i>  标题及顶图
            </div>
        </div>
            <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
            <div class="fl-le flex align-cen">
                        <div class="label">文字标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入文字标题" v-model="params.contact.title1" clearable maxlength="20"> </el-input>
                    </div>
               </div>
                 <div class="fl-rt flex align-cen">
                        <div class="label">副文案：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副文案" v-model="params.contact.title1s" clearable maxlength="20"> </el-input>
                    </div>
                 </div>
         </div>
                       <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
             <div class="fl-le flex align-cen">
                       <div class="label">联系顶图：</div>
                    <div class="el-select1">
                     <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :before-upload="$util.beforeUpload"
                     :on-success="(res)=>{handlePictureCardSuccess(res,12)}"
                    :disabled="uploadBoolean12"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">1920*396</span></div>
                         <img :src="params.contact.logo" class="avatar" v-if="params.contact.logo">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="params.contact.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(12)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(12)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                 <el-dialog :visible.sync="picDialog11" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="params.contact.logo" alt="">
                    </el-dialog>
                    </el-upload>
                    </div>
                    </div>
           </div>
              <!-- <div class="public-tit flex align-cen" style="margin-top:20px"> 
            <div class="public-tit-list">
                <i class="icon-al-edit"></i>  公司地址
            </div>
        </div>
             <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
             <div class="fl-le flex align-cen">
                <div class="label">所属城市：</div>
                <div class="el-select1">
                  <el-cascader
                            size="large"
                            :options="options1"
                            v-model="selectedOptions"
                            @change="addHandleChange"
                            placeholder="请选择省/市/区"
                            clearable
                            >
                     </el-cascader>
                </div>
             </div>
               <div class="fl-rt flex align-cen">
                        <div class="label" style="width:100px">公司地址：</div>
                    <div class="el-select1 el-map">
                    <el-input placeholder="请输入详细地址" v-model="params.contact.address" clearable > </el-input>
                    </div>
                    <div class="el-btn mft" @click="openMap">
                      <div class="public-btn-small-primary">
                        地图标注
                      </div>
                    </div>
                 </div>
             </div> -->
                    <!-- 富文本 -->
            <div class="public-tit flex align-cen" style="margin-top:20px" id="addCanvas" v-if="contactList.length == 0">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  分类
            </div>
               <div class="mft public-btn-small">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(-1,3)"
                     >
                          添加分类  
                    </div>
                </div>
        </div>
          <div class="AppContent">
                    <div class="moreCanvas"
                     v-for="(item,index) in contactList"
                    :key="index"
                    :id="'addCanvas'+index"
                    >
                            <div class="public-tit flex align-cen" style="margin-bottom:20px">
                        <div class="public-tit-list">
                            <i class="icon-al-database-fill"></i> 分类{{index+1}}
                        </div>
                    </div>
                             <div class="businessList-filter-list flex align-cen">
                        <div class="fl-le flex align-cen">
                    <div class="label">分类标题：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入分类标题【1-5】" v-model="item.title" clearable
                        maxlength="5"
                        > </el-input>
                    </div>
                    </div>
                        <div class="fl-rt flex align-cen">
                    <div class="label">副标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副标题【1-50】" v-model="item.subhead" clearable maxlength="50"> </el-input>
                    </div>
                    </div>
                    <div class="mft deletBtn"
                    @click="deletCanvas(item,index,3)"
                    >
                    删除分类
                    </div>
                    <div class="mft public-btn-small" style="padding-left:0" v-if="index == contactList.length-1">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(index+1,3)"
                     >
                          添加分类  
                    </div>
                </div>
                </div>
                  <quillsTemplate  @sendStatus="emitFun" 
                     :propData="item.content"
                     :currindex="index"
                     :tempname="3"
                      :activeIndex="activeIndex"
                    :ref="'quillTemplate' + index"
                    ></quillsTemplate>
        </div>
          </div>
       </div>
     </el-tab-pane>
     <el-tab-pane label="资质荣誉" name="9">
       <span slot="label"><i class="icon-al-gem"></i>资质荣誉</span>
       <div class="honor">
                <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-edit"></i>  标题及顶图
            </div>
        </div>
             <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
            <div class="fl-le flex align-cen">
                        <div class="label">文字标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入文字标题" v-model="params.honor.title1" clearable maxlength="20"> </el-input>
                    </div>
               </div>
                 <div class="fl-rt flex align-cen">
                        <div class="label">副文案：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副文案" v-model="params.honor.title1s" clearable maxlength="20"> </el-input>
                    </div>
                 </div>
         </div>
                  <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
             <div class="fl-le flex align-cen">
                       <div class="label">资质顶图：</div>
                    <div class="el-select1">
                     <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :before-upload="$util.beforeUpload"
                     :on-success="(res)=>{handlePictureCardSuccess(res,11)}"
                    :disabled="uploadBoolean11"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">1920*396</span></div>
                         <img :src="params.honor.logo" class="avatar" v-if="params.honor.logo">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div v-if="params.honor.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(11)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(11)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                 <el-dialog :visible.sync="picDialog10" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="params.honor.logo" alt="">
                    </el-dialog>
                    </el-upload>
                    </div>
                    </div>
           </div>
              <!-- 富文本 -->
            <div class="public-tit flex align-cen" style="margin-top:20px" id="addCanvas" v-if="honorList.length == 0">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  分类
            </div>
               <div class="mft public-btn-small">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(-1,4)"
                     >
                          添加分类  
                    </div>
                </div>
        </div>
             <div class="AppContent">
                    <div class="moreCanvas"
                     v-for="(item,index) in honorList"
                    :key="index"
                    :id="'addCanvas'+index"
                    >
                            <div class="public-tit flex align-cen" style="margin-bottom:20px">
                        <div class="public-tit-list">
                            <i class="icon-al-database-fill"></i> 分类{{index+1}}
                        </div>
                    </div>
                             <div class="businessList-filter-list flex align-cen">
                        <div class="fl-le flex align-cen">
                    <div class="label">分类标题：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入分类标题【1-5】" v-model="item.title" clearable
                        maxlength="5"
                        > </el-input>
                    </div>
                    </div>
                        <div class="fl-rt flex align-cen">
                    <div class="label">副标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副标题【1-50】" v-model="item.subhead" clearable maxlength="50"> </el-input>
                    </div>
                    </div>
                    <div class="mft deletBtn"
                    @click="deletCanvas(item,index,4)"
                    >
                    删除分类
                    </div>
                    <div class="mft public-btn-small" style="padding-left:0" v-if="index == honorList.length-1">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(index+1,4)"
                     >
                          添加分类  
                    </div>
                </div>
                </div>
                  <quillsTemplate  @sendStatus="emitFun" 
                     :propData="item.content"
                     :currindex="index"
                     :tempname="4"
                     :activeIndex="activeIndex"
                    :ref="'quillTemplate' + index"
                    ></quillsTemplate>
        </div>
          </div>
       </div>
     </el-tab-pane>
  </el-tabs>
    <el-dialog
  :visible.sync="centerDialogVisible"
   width="70vw"
  custom-class = "addPro"
  title="地图标注"
 :append-to-body="true"
  v-if="centerDialogVisible"
  center>
<bdmap  @sendStatus="isshowfase" @addInfo = "emitInfo" :sendformLabelAlign="params.contact"></bdmap>
    </el-dialog>
    </div>
</template>
<script>
import LocaStorage from "../../../utils/localstorage.js" //本地存储公共方法
import quillsTemplate from "@/components/quills";  //多富文本组件
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'  //省市区级联
import bdmap from "@/components/BdMap"  //地图组件
import { websitePage,websitePageList} from "@/api/index/index"  //保存页面配置、页面配置信息列表
import { title } from '@/settings.js';
import { number } from 'echarts';
export default {
   inject: ["reload"],
    name:'indexConfig',
    components:{
        quillsTemplate,
        bdmap
    },
    data () {
        return {
            chdis:true,
            Htmlloading:true,
            centerDialogVisible:false,
            options1: regionData,
            selectedOptions: [],
            nowIndex:0,
            platformAppContentList:[],
            chairmanList:[],
            hlyhList:[],
            honorList:[],
            contactList:[],
            activeIndex:'1',
            uploadBoolean1:false,
            uploadBoolean2:false,
            uploadBoolean3:false,
            uploadBoolean4:false,
            uploadBoolean5:false,
            uploadBoolean6:false,
            uploadBoolean7:false,
            uploadBoolean8:false,
            uploadBoolean9:false,
            uploadBoolean10:false,
            uploadBoolean11:false,
            uploadBoolean12:false,
            uploadBoolean13:false,
            dialogImageUrl:'',
            dialogImageUrl1:'',
            picDialog0:false,
            dialogVisible1:false,
            dialogVisible2:false,
            picDialog1:false,
            picDialog2:false,
            picDialog3:false,
            picDialog4:false,
            picDialog5:false,
            picDialog6:false,
            picDialog7:false,
            picDialog8:false,
            picDialog9:false,
            picDialog10:false,
            picDialog11:false,
            picDialog12:false,
            header:{},
            loading:false,
            addDetail:{},
            alladdress:'',
            params:{
                index:
                  {
                      logo:'',
                      moreTimg:[],
                      moreImg:[],
                      title1:'',
                      title2:'',
                      title3:'',
                      title4:'',
                      pic1:'',
                      pic2:'',
                      pic3:'',
                      pic4:'',
                      serveText1:'',
                      serveText2:'',
                      serveText3:'',
                      serveText4:'',
                      serveBotText1:'',
                      serveBotText2:'',
                      serveBotText3:'',
                      serveBotText4:''
                  },
                partner:{
                  title1:'',
                  title1s:'',
                  logo:'',
                },
                news:{
                  title1:'',
                  title1s:'',
                  logo:''
                },
                help:{
                  title1:'',
                  title1s:'',
                  logo:''
                },
                chairman:{
                  title1:'',
                  title1s:'',
                  logo:''
                },
                recruit:{
                 title1:'',
                  title1s:'',
                  logo:''
                },
                hlyh:{
                  title1:'',
                  title1s:'',
                  logo:''
                },
                  contact:{
                  title1:'',
                  title1s:'',
                  logo:'',
                  address:'',
                  longi:'',
                  lati:'',
                },
                honor:{
                  title1:'',
                  title1s:'',
                  logo:''
                }
            }
        }
    },
    activated() {
          this.getWebsitePage()
        this.getWebsitePage1()
    },
    created() {
              let token = LocaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
      // 地址选择
      addHandleChange(value){
        // console.log(value)
       if (value[1] != null && value[2] != null) {
        this.alladdress = CodeToText[value[0]] +'-' + CodeToText[value[1]] + '-' + CodeToText[value[2]]
      } else {
        if (value[1] != null) {
         this.alladdress = CodeToText[value[0]] + '-' + CodeToText[value[1]]
        } else {
          this.alladdress = CodeToText[value[0]]
        }
      }
      },
      // 获取页面配置信息
      getWebsitePage(){
      this.params.index.moreImg = []
      this.params.index.moreTimg = []

       let assignArr = ['index','partner','news','help','chairman','recruit','hlyh','contact','honor'] 
        websitePageList({type:''})
        .then(res =>{
          this.Htmlloading = false
          if(res.code == 0){
             assignArr.forEach((t,k) => {
             let arrName = k == 1 ? 'platformAppContentList' : k == 4 ? 'chairmanList' : k == 6 ? 'hlyhList' : k == 7 ? 'contactList' : 'honorList'
             this[arrName] = []
              // 过滤数据
              let indexData = res.data.filter(item => Number(item.type) == k+1)
               if(k==0){
                // 首页赋值
                  let titleData, 
                      picData,
                      serveTextData,
                      serveBotTextData
                      for (let i = 1; i < 5; i++) {
                        titleData = res.data.filter(item => item.attributeName ==  ('title' + i))
                        picData = res.data.filter(item => item.attributeName ==  ('pic' + i))
                        serveTextData = res.data.filter(item => item.attributeName ==  ('serveText' + i))
                        serveBotTextData = res.data.filter(item => item.attributeName ==  ('serveBotText' + i))
                      this.params['index']['title' + i]  = titleData[0].attributeValue
                      this.params['index']['pic' + i]  =  picData[0].attributeValue
                      this.params['index']['serveText' + i]  =  serveTextData[0].attributeValue
                      this.params['index']['serveBotText' + i]  =  serveBotTextData[0].attributeValue
                      }
    
                  // 合作伙伴赋值
                  let moreImgData = res.data.filter(item => !item.attributeName.indexOf("moreImg"))
                  let moreTimgData = res.data.filter(item => !item.attributeName.indexOf("moreTimg"))
                  // console.log(moreImgData) 
                  // moreImgData.reverse()
                  // moreTimgData.reverse()
                  for (const key in moreImgData) {
                this.params.index.moreImg.push(
                      {
                    url:moreImgData[key].attributeValue,
                    response:{
                      data:{
                        url:moreImgData[key].attributeValue
                      }
                    }
                  }
                   )
                  }  
                     for (const key in moreTimgData) {
                this.params.index.moreTimg.push(
                      {
                    url:moreTimgData[key].attributeValue,
                    response:{
                      data:{
                        url:moreTimgData[key].attributeValue
                      }
                    }
                  }
                   )
                  }               
               }else{
                   if(indexData.length > 3){
                     let contentData = indexData.filter(item => !item.attributeName.indexOf("content")),
                         temTitData = indexData.filter(item => !item.attributeName.indexOf("temTit")),
                         subheadData = indexData.filter(item => !item.attributeName.indexOf("subhead"))
                         contentData.forEach((item,index) =>{
                          if(item.attributeValue !=null){
                         if(index != item.attributeName.charAt(item.attributeName.length-1)) contentData.reverse(),temTitData.reverse(),subheadData.reverse()
                         this[arrName].push({
                          content:contentData[index].attributeValue,
                          title:temTitData[index].attributeValue,
                          subhead:subheadData[index].attributeValue ,
                        })
                          }
                     })
                     
                    }
                    // console.log(indexData)
                  indexData.forEach(item =>{
                    if(item.attributeName == "logo") this.params[t].logo  = item.attributeValue
                    if(item.attributeName == "title1") this.params[t].title1  = item.attributeValue
                    if(item.attributeName == "title1s") this.params[t].title1s  = item.attributeValue
                 
                    // if(item.attributeName == "address") this.params[t].address  = item.attributeValue
                    // if(item.attributeName == "alladdress") {

                    //   let allstr = item.attributeValue.split("-")
                    //   this.selectedOptions = [TextToCode[allstr[0]].code, TextToCode[allstr[0]][allstr[1]].code, TextToCode[allstr[0]][allstr[1]][allstr[2]].code]
                    // }
                  })
      
               }
             })

              // console.log(res)
          }else{
            this.Htmlloading = false
            this.$util.Notifi(err.msg ,'error','fa-exclamation-circle');
          }
        })
        .catch(err =>{
        })
      },
      getWebsitePage1(){
         websitePageList({type:0})
        .then(res =>{
          if(res.code == 0){
           this.params.index.logo = res.data[0].attributeValue
          }
        })
        .catch(err =>{
        })
      },
      // 保存页面配置
      onSubmit(){
        // console.log(this.params.index.moreImg)
        // 组装数据
        let paramsList = [
            {
              type:0,
              attributeName:'homeLogo',
              attributeValue:this.params.index.logo
            },
           ]
           for (let index = 1; index < 5; index++) {
            paramsList.push({
              type:1,
              attributeName:'title' + index,
              attributeValue:this.params.index['title'+index]
            },
            {
              type:1,
              attributeName:'pic' + index,
              attributeValue:this.params.index['pic'+index]
            },
            {
              type:1,
              attributeName:'serveText' + index,
              attributeValue:this.params.index['serveText'+index]
            },
            {
              type:1,
              attributeName:'serveBotText' + index,
              attributeValue:this.params.index['serveBotText'+index]
            }
            )
           }
          for (let index = 0; index < this.params.index.moreImg.length; index++) {
            paramsList.push({
              type:1,
              attributeName:'moreImg' + index,
              attributeValue:this.params.index.moreImg[index].response.data.url
            })
          }
           for (let index = 0; index < this.params.index.moreTimg.length; index++) {
            paramsList.push({
              type:1,
              attributeName:'moreTimg' + index,
              attributeValue:this.params.index.moreTimg[index].response.data.url
            })
          }
          let typeArr = ['','','partner','news','help','chairman','recruit','hlyh','contact','honor'] 
          for (let index = 2; index < typeArr.length; index++) {
            paramsList.push({
              type:index,
              attributeName:'title1',
              attributeValue:this.params[typeArr[index]].title1
            },
            {
              type:index,
              attributeName:'title1s',
              attributeValue:this.params[typeArr[index]].title1s
            },
            {
              type:index,
              attributeName:'logo',
              attributeValue:this.params[typeArr[index]].logo
            }
            )
          }
          
          paramsList.push({
             type:8,
             attributeName:'alladdress',
             attributeValue:this.alladdress
          },
          {
             type:8,
             attributeName:'address',
             attributeValue:this.params.contact.address
          }
          )
          const paramsKey = ['platformAppContentList','chairmanList','hlyhList','contactList','honorList']
            paramsKey.forEach((t,index) => {
            let type = index == 0 ? 2 : index == 1 ? 5 : index == 2 ? 7 : index == 3 ? 8 : 9
              this[t].forEach((i,index1) => {
                paramsList.push({
                  type:type,
                  attributeName:'temTit' + index1,
                  attributeValue:i.title
                },
                {
                  type:type,
                  attributeName:'subhead' + index1,
                  attributeValue:i.subhead
                },
                 {
                  type:type,
                  attributeName:'content' + index1,
                  attributeValue:i.content
                }
                )
              });
            })
          this.loading = true
          websitePage(paramsList)
          .then(res => {
            this.loading = false
            if(res.code == 0){
              this.$util.Notifi('配置成功','success','fa-check'); 
              this.reload();
            }else{
              this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
            }
          })
          .catch(err =>{
            this.loading = false
          })

      },
        // 地图传过来的信息
      emitInfo(info){
        let jsonInfo = JSON.parse(info)
        this.centerDialogVisible = false
        this.addDetail = jsonInfo
        this.params.contact.address = jsonInfo.address
        this.params.contact.longi = jsonInfo.longitude
        this.params.contact.lati = jsonInfo.latitude
      },
      isshowfase(){},
      // 打开地图
      openMap(){
        this.centerDialogVisible =true
      },
          // 子组件触发的方法
        emitFun(val,i,name){
          const canKey = ['platformAppContentList','chairmanList','hlyhList','contactList','honorList']
            canKey.forEach((t,index) => {
            if(name == index){
              this[t][i].content = val
            }
          });
        },
         // 删除分类
        deletCanvas(data,nowIndex,name){
            let arr = []
             arr.push(data)
              const deletCan = ['platformAppContentList','chairmanList','hlyhList','contactList','honorList']
              deletCan.forEach((t,index) => {
                if(name == index){
                  if(nowIndex != this[t].length-1){
                    return this.$util.Notifi('请先删除分类' +this[t].length ,'error','fa-exclamation-circle');
                  }else{
                    this[t]= this[t].filter(item=>!arr.some(ele=>ele ===item))
                  }
                }
              })
        },
      // 添加分类
        addCanvas(i,name){
          // 优化
          const canKey = ['platformAppContentList','chairmanList','hlyhList','contactList','honorList']
          canKey.forEach((t,index) => {
            if(name == index){
              this[t].push({
                title:'',
                subhead:'',
                content:'',
              })
            }
          });
          // switch(name){
          //   case 'partner':
          //     return this.platformAppContentList.push({title:'',subhead:'',content:''})
          //   case 'chairman':
          //     return this.chairmanList.push({title:'',subhead:'',content:''})
          //   case 'hlyh':
          //     return this.hlyhList.push({title:'',subhead:'',content:''})
          //   case 'honor':
          //     return this.honorList.push({title:'',subhead:'',content:''})
          //   case 'contact':
          //     return this.contactList.push({title:'',subhead:'',content:''})
          // }
        },
         // 多图上传
      handleChange(file, fileList,type){
         if(type == 1 ) return this.params.index.moreImg = fileList.slice();
      if(type == 2 ) return this.params.index.moreTimg = fileList.slice();
      },
      // 多图移除
      handleRemove(file, fileList,type){
      if(type == 1 ) return this.params.index.moreImg = fileList.slice();
      if(type == 2 ) return this.params.index.moreTimg = fileList.slice();
      },
          // 多图预览
       handlePictureCardPreview(file,type) {
        if(file.imgUrl){
          if(type == 1) this.dialogImageUrl = file.imgUrl;
          if(type == 2) this.dialogImageUrl1 = file.imgUrl;
        }else{
          if(type == 1) this.dialogImageUrl = file.url
          if(type == 2) this.dialogImageUrl1 = file.url
        }
        type == 1 ? this.dialogVisible1 = true : this.dialogVisible2 = true;
      },
       // 单图上传成功
        handlePictureCardSuccess(res,type){
          // 优化
          const typeKey = ['index','index','index','index','index','news','help','chairman','recruit','hlyh','honor','contact','partner'] 
          typeKey.forEach((t,index) => {
            if(type == index+1){
              if(type == 2 || type == 3 || type == 4 || type == 5){
                this.params[t]['pic' + index] = res.data.url
              }else{
                this.params[t].logo = res.data.url
              }
              this['uploadBoolean' + type]  = true 
              }
            })
        },
    // 单图预览
       oploadImgPre(type) {
        // 优化
          this['picDialog'+ (type-1)] = true
      },
    //   单图删除
       oploadImgDel(type){
        // 优化
        let _this= this
         const deletKey = ['index','index','index','index','index','news','help','chairman','recruit','hlyh','honor','contact','partner'] 
            deletKey.forEach((t,index) => {
            if(type == index+1){
              if(type == 2 || type == 3 || type == 4 || type == 5){
                this.params[t]['pic' + index] = ''
              }else{
                this.params[t].logo = ''
              }
               setTimeout(function(){
                    _this['uploadBoolean' + type] = false
                },1000)
              }
            })
            },
    },
}
</script>
<style lang="scss" scoped>
#indexConfig{
    margin-bottom: 60px;
    .businessList-filter-list{
      .fl-le{
        width: 50%;
      }
      .fl-rt{
        width: 50%;
      }
              .el-select1{
          padding-left: 20px;
           width: 80%;
          .el-input,.el-cascader{
           width: 80%;
          }
        }
        .el-map{
          .el-input{
            width: 90% !important;
          }
        }
                  .el-btn{
                    width: 20%;
            .public-btn-small-primary{
              height: 32px;
              line-height: 30px;
              font-size: 14px;
              border-radius: 2px;
              font-family: inherit;
              border-width: 1px;
              border-style: solid;
              text-align: center;
              vertical-align: middle;
              box-sizing: border-box;
              cursor: pointer;
              transition: all 0.3s;
              background: #155bd4;
              color: #fff;
            }
          }
    }
    .el-price-table {
      margin-top: 20px;
    }
    .el-price-serve{
      margin-top: 20px;
      .serve-upload-list{
        width: 25%;
      }

    }
         .AppContent{
        margin: 20px 0;
        margin-bottom: 100px;
        position: relative;
        .moreCanvas{
            margin-top: 60px;
        }
        .moreCanvas:first-child{
            margin-top: 0;
        }
           .el-select1{
                width: 80%;
            }
        .fl-le{
            width: 40%;
        }
        .fl-rt {
             width: 40%;
        padding-left: 30px;
      }
      .deletBtn{
        margin-left: 30px;
        height: 32px;
        line-height: 30px;
        font-size: 14px;
        padding: 0 16px;
        border-radius: 2px;
        font-family: inherit;
        border-width: 1px;
        border-style: solid;
        text-align: center;
        vertical-align: middle;
        box-sizing: border-box;
        cursor: pointer;
        transition: all 0.3s;
        background: #f56c6c;
        color: #fff;
      }
      .el-input,.el-cascader{
            width: 100%;
        }
     }
}
  ::v-deep{
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploaderlogo{
      .el-upload--picture-card {
        font-size: 28px;
        color: #8c939d;
        width: 209px;
        height: 88px;
        line-height: 88px;
        text-align: center;
    }
            .el-upload-list__item{
           width: 209px ;
        height: 88px;
        line-height: 88px;
        .el-upload-list__item-status-label{
          .el-icon-upload-success{
            position: absolute;
    top: 1px;
    right: 14px
          }
        }
        }
  }
  .pic-uploader{
    .el-upload{
      width: 180px;
      height: 180px;
      .avatar-uploader-icon{
            font-size: 28px;
    color: #8c939d;
    width: 180px;
    height: 180px;
    line-height: 180px;
    text-align: center;
      }
      .avatar{
        width: 180px;
        height: 180px;
      }
      .el-upload-list__item-actions{
        height: 180px;
        .upload-icon {
    position: absolute;
    top: 50%;
    margin-left: -21px;
    margin-top: -10px;
}
      }
    }
    .el-input{
      width: 180px;
    }
  }
    .avatar-uploaderlogo1{
      .el-upload--picture-card {
        font-size: 28px;
        color: #8c939d;
        width:159px;
        height: 187px;
        line-height: 187px;
        text-align: center;
    }
            .el-upload-list__item{
           width:159px;
        height: 187px;
        line-height: 187px;
           .el-upload-list__item-status-label{
          .el-icon-upload-success{
            position: absolute;
    top: 1px;
    right: 14px
          }
        }
        }
  }
  
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 220px;
    height: 140px;
    line-height: 140px;
    text-align: center;
  }
  .avatar {
    width: 220px;
    height: 140px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 220px;
        height: 140px;
        line-height: 140px;
        text-align: center;
    }
    .el-select1{
           .el-upload-list__item-actions{
               width: 100%;
    height: 180px;
        position: absolute;
    z-index: 99;
    top: 0;
    left: 0;
     }
    .el-upload-list__item-actions:hover{
    background: rgba(255,255,255,.6);
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -33px;
    }
    }
    .el-dialog{
        width: 30%;
    }
    .el-list-enter-active,.el-list-leave-active{
        transition: none;
    }
    .el-list-enter,.el-list-leave-active {
      opacity: 0;
    }
    .el-upload-list {
      height: 40px;
    }
  }
</style>